import { atom, selectorFamily } from 'recoil';
import { DepositService } from 'api';
export const getCustomerDepositRequestId = atom({
  key: 'getCustomerDepositRequestId',
  default: 0
});
export const getCustomerDeposit = selectorFamily({
  key: 'getCustomerDeposit',
  get: customerId => async ({
    get
  }) => {
    get(getCustomerDepositRequestId);
    if (!customerId) return null;
    try {
      const result = await DepositService.getCustomerDeposit({
        customerId: customerId
      });
      return result ?? null;
    } catch (error) {
      console.error('Error fetching customer deposit', error);
      return null;
    }
  }
});